<template>
    <section>
        <b-modal :id="modalId" :ref="modalId" size="lg" title="Pick Item Confirm">
            <b-row>
                <b-col cols="1">
                    <dt>Sales Order</dt>
                    <dd>{{ orderedItem.salesOrderId }}</dd>
                </b-col>
                <b-col cols="2">
                    <dt>Date</dt>
                    <dd>{{ date(orderedItem.soDate) }}</dd>
                </b-col>
                <b-col cols="3">
                    <dt>Customer</dt>
                    <dd>{{ orderedItem.companyName }}</dd>
                </b-col>
                <b-col cols="3">
                    <dt>Contact</dt>
                    <dd>{{ orderedItem.contactFirstName + ' ' + orderedItem.contactLastName }}</dd>
                </b-col>
                <b-col cols="3">
                    <dt>Sales Rep</dt>
                    <dd>{{ orderedItem.salesPersonUserFullName }}</dd>
                </b-col>
            </b-row>
            <b-row class="mt-1">
                <b-col cols="3">
                    <dt>Part</dt>
                    <dd>{{ orderedItem.partNumber }}</dd>
                </b-col>
                <b-col cols="2">
                    <dt>Ordered</dt>
                    <dd>{{ commafy(orderedItem.quantitySold) }}</dd>
                </b-col>
                <b-col cols="2">
                    <dt>Shipped</dt>
                    <dd>{{ commafy(orderedItem.quantityShipped) }}</dd>
                </b-col>
                <b-col cols="2">
                    <dt>Backordered</dt>
                    <dd>{{ commafy(orderedItem.quantityBackordered) }}</dd>
                </b-col>
                <b-col cols="3">
                    <dt>On-Order</dt>
                    <dd>{{ commafy(orderedItem.quantityInbound) }}</dd>
                </b-col>
            </b-row>
            <b-row class="mt-1">
                <b-col cols="4">
                    <dt>Description</dt>
                    <dd>{{ orderedItem.description }}</dd>
                </b-col>
                <b-col cols="2">
                    <dt>Packaging</dt>
                    <dd>{{ orderedItem.package }}</dd>
                </b-col>
                <b-col cols="2">
                    <dt>SPQ</dt>
                    <dd>{{ orderedItem.piecePerPkg }}</dd>
                </b-col>
                <b-col cols="2">
                    <dt>Phys Pkg</dt>
                    <dd>{{ orderedItem.physPkg }}</dd>
                </b-col>
                <b-col cols="2">
                    <dt>RoHS</dt>
                    <dd>{{ orderedItem.leadFree }}</dd>
                </b-col>
            </b-row>
            <hr/>
            <p>Please confirm that item details pulled from inventory and click Save.</p>
            <b-row>
                <b-col cols="2">
                    <b-form-group label="Qty To Ship">
                        <b-form-input v-model="orderedItem.qtyToShip" />
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group label="Max">
                        <span>{{commafy(orderedItem.quantity)}}</span>
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group label="Date Due">
                        <span class="mt-1">{{ date(orderedItem.customerDueDate) }}</span>
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group label="Ship via">
                        <span class="mt-1">{{orderedItem.shippingProviderName}}</span>
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group label="By">
                        <b-form-select v-model="confirmedUserId" class="w-auto" @change="onConfirmedUserChange">
                            <option v-for="(selectRep, indexRep) in sortSelect(salesReps)" :key="indexRep" :value="selectRep.id">
                                {{ selectRep.name }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-1">
                <b-col>
                    <table class="table table-borderless">
                        <tr>
                            <th></th>
                            <th>Ordered</th>
                            <th>Inventory (Pulling)</th>
                            <th>Confirm</th>
                        </tr>
                        <tr>
                            <th>Part</th>
                            <td>{{ orderedItem.partNumber }}</td>
                            <td>{{ pickLineItem.partNumber }}</td>
                            <td><b-form-checkbox v-model="pickLineItem.partNumberConfirmed"> Confirm</b-form-checkbox></td>
                        </tr>
                        <tr>
                            <th>Mfr</th>
                            <td>{{ orderedItem.mfgName }}</td>
                            <td>{{ pickLineItem.manufacturerName }}</td>
                            <td><b-form-checkbox v-model="pickLineItem.manufacturerConfirmed"> Confirm</b-form-checkbox></td>
                        </tr>
                        <tr>
                            <th>Quantity</th>
                            <td>{{ commafy(orderedItem.quantity) }}</td>
                            <td>{{ commafy(pickLineItem.quantityToPull) }}</td>
                            <td>
                                <b-form-group label-cols="2" label-align="right" label="Pulled">
                                    <b-form-input v-model="pickLineItem.quantityPulled" style="margin-left: 10px; max-width: 75px" />
                                </b-form-group>
                            </td>
                        </tr>
                        <tr>
                            <th>Date Code</th>
                            <td>{{ orderedItem.dateCode }}</td>
                            <td>{{ pickLineItem.dateCode }}</td>
                            <td><b-form-checkbox v-model="pickLineItem.dateCodeConfirmed"> Confirm</b-form-checkbox></td>
                        </tr>
                        <tr>
                            <th>Lot Code</th>
                            <td>{{ orderedItem.lotCode }}</td>
                            <td>{{ pickLineItem.lotCode }}</td>
                            <td><b-form-checkbox v-model="pickLineItem.lotCodeConfirmed"> Confirm</b-form-checkbox></td>
                        </tr>
                        <tr>
                            <th>Revision</th>
                            <td>{{ orderedItem.revision }}</td>
                            <td>{{ pickLineItem.revision }}</td>
                            <td><b-form-checkbox v-model="pickLineItem.revisionConfirmed"> Confirm</b-form-checkbox></td>
                        </tr>
                        <tr>
                            <th>Condition</th>
                            <td>{{ orderedItem.condition }}</td>
                            <td>{{ pickLineItem.conditionName }}</td>
                            <td><b-form-checkbox v-model="pickLineItem.conditionConfirmed"> Confirm</b-form-checkbox></td>
                        </tr>
                        <tr>
                            <th>COO</th>
                            <td>{{ orderedItem.countryOfOriginName }}</td>
                            <td>{{ pickLineItem.countryOfOriginName }}</td>
                            <td><b-form-checkbox v-model="pickLineItem.cooConfirmed"> Confirm</b-form-checkbox></td>
                        </tr>
                    </table>
                </b-col>
            </b-row>
            <template slot="modal-footer">
                <b-button variant="primary" class="mr-auto" @click="$bvModal.show(serialNumbersModal)"> Serial Numbers</b-button>
                <!-- <b-button @click="$bvModal.hide(modalId)">Cancel</b-button> -->
                <b-button variant="primary" @click="onSavePickListConfirm">OK</b-button>
            </template>
        </b-modal>
        <pick-list-serial-numbers :modalId="serialNumbersModal" :serialNumbers="pickLineItem.inventorySerialNumber" />
    </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { date } from '@/shared/filters';
import PickListSerialNumbers from '../PickListSerialNumbers';

export default {
    props: {
        orderedItem: {
            type: Object,
            default: () => {}
        },
        pickLineItem: {
            type: Object,
            default: () => {}
        },
        modalId: {
            type: String,
            default: 'pick-list-confirmation-modal'
        }
    },
    components: {
        PickListSerialNumbers
    },
    data: () => ({
        date,
        confirmedUserId: ''
    }),
    computed: {
        ...mapGetters('account', ['isSalesRep', 'userId']),
        ...mapState('salesReps', ['salesReps']),
        serialNumbersModal() {
            return this.modalId + '-serial-numbers';
        },
        isConfirmedPickItem() {
            return this.pickLineItem.partNumberConfirmed && this.pickLineItem.manufacturerConfirmed && this.pickLineItem.dateCodeConfirmed && this.pickLineItem.lotCodeConfirmed
            && this.pickLineItem.revisionConfirmed && this.pickLineItem.conditionConfirmed
            && this.pickLineItem.cooConfirmed && this.pickLineItem.quantityToPull == this.pickLineItem.quantityPulled;
        }
    },
    methods: {
        ...mapActions('salesReps', ['getSalesReps']),
        onConfirmedUserChange(id) {
            this.pickLineItem.confirmedByUserId = id;
        },
        onSavePickListConfirm() {
            this.pickLineItem.isConfirmed = this.isConfirmedPickItem;
            this.pickLineItem.confirmedByUserId = this.confirmedUserId;
            this.$bvModal.hide(this.modalId);
        },

        commafy(num, currency = "", decimal = 2) {
            try {
                if (num != null) {
                    if (currency != "") {
                        num = Number(num).toFixed(decimal);
                    }
                    var str = num.toString().split('.');
                    if (str[0].length >= 3) {
                        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
                    }
                    if (str[1]) {
                        if (str[1].length < decimal) {
                        while (str[1].length < decimal) { str[1] = str[1] + "0"; }
                        } else if (str[1].length > decimal) {
                        str[1] = str[1].substring(0, decimal)
                        }
                    }
                    return currency + str.join('.');
                }
            } catch {
                return num;
            }
        }
    },
    mounted() {
        this.getSalesReps().then(() => {
            if (this.isSalesRep) { this.confirmedUserId = this.userId; }
        });
    }

}
</script>

<style scoped>
    table > tr > th:first-child {
        text-align: right;
    }
    .table th {
        padding: 0.3rem;
    }
    .table td {
        padding: 0.3rem;
    }
</style>